import React, { useEffect, useState } from 'react';
import { bool, arrayOf, oneOfType } from 'prop-types';
import Slider from "react-slick";
import { compose } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import {
  REVIEW_TYPE_OF_PROVIDER,
  REVIEW_TYPE_OF_CUSTOMER,
  SCHEMA_TYPE_MULTI_ENUM,
  SCHEMA_TYPE_TEXT,
  propTypes,
  primeListing,
  subListing,
  LISTING_STATE_DRAFT,
  userTypePrime,
} from '../../util/types';
import {
  NO_ACCESS_PAGE_USER_PENDING_APPROVAL,
  PROFILE_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { richText } from '../../util/richText';
import { isUserAuthorized } from '../../util/userHelpers';
import { pickCustomFieldProps } from '../../util/fieldHelpers';
import { createResourceLocatorString } from '../../util/routes';
import { ensureUser, userDisplayNameAsString } from '../../util/data';
import { isErrorUserPendingApproval, isForbiddenError, isNotFoundError } from '../../util/errors';

import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import {
  Heading,
  H2,
  H4,
  Page,
  Menu,
  Modal,
  Reviews,
  MenuItem,
  MenuLabel,
  MenuContent,
  NamedLink,
  ShareModal,
  AvatarLarge,
  NamedRedirect,
  PrimaryButton,
  LayoutSideNavigation,
  InviteProfessionalModal,
  ButtonTabNavHorizontal,
  ProposalModal,
  InlineTextButton,
} from '../../components';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';

import SectionTextMaybe from './SectionTextMaybe';
import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import InquiryForm from '../ListingPage/InquiryForm/InquiryForm';
import { types as sdkTypes } from '../../util/sdkLoader';
import { contactProfessional, inviteProfessional, sendProposal, showUser } from './ProfilePage.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';

import css from './ProfilePage.module.css';
import { accountTypes } from '../../config/configSearch';
const { UUID } = sdkTypes;

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <svg width="40px" height="40px" viewBox="0 0 2.4 2.4" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="none" width="48" height="48" fill-opacity="0.01" d="M0 0H2.4V2.4H0V0z" /><path d="m0.95 0.6 0.6 0.6 -0.6 0.6" stroke="#000000" stroke-width="0.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", }}
      onClick={onClick}
    >
      <svg width="40px" height="40px" viewBox="0 0 2.4 2.4" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="none" width="48" height="48" fill-opacity="0.01" d="M0 0H2.4V2.4H0V0z" /><path d="M1.55 1.8 0.95 1.2l0.6 -0.6" stroke="#000000" stroke-width="0.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
    </div>
  );
}

const MAX_MOBILE_SCREEN_WIDTH = 768;
const MIN_LENGTH_FOR_LONG_WORDS = 20;

export const AsideContent = props => {
  const {
    user,
    displayName,
    listings,
    currentUser,
    config,
    onShowUser,
    currentUserListings,
    onSendProposal,
    sendProposalInProgress,
    sendProposalError,
    showLinkToProfileSettingsPage,
    onInviteProfessional,
    inviteProfessionalInProgress,
    inviteProfessionalError,
    onContactProfessional,
    currentUserHasListings,
    isCurrentUserProfessional,
    onManageDisableScrolling,
    contactProfessionalError,
    contactProfessionalInProgress,
  } = props;

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const [state, setState] = useState({
    isInviteProfessionalModalOpen: false,
    isShareModalOpen: false,
    isEnquiryModalOpen: false,
    isSubscriptionModalOpen: false,
    isProposalModalOpen: false,
  });
  const profileUser = ensureUser(user);
  const isprofileUser = profileUser.id.uuid;
  const { publicData, title, state: listingState } = (listings && listings.length && listings[0].attributes) || {};
  const listingId = listings[0]?.id;
  const currentAuthor = listings[0]?.author || {};
  const ensuredAuthor = ensureUser(currentAuthor);
  const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');
  const { professional_Skills, documents, listingType } = publicData || {}
  const isOwnListing = (listings[0] && listings[0].author && listings[0].author.id.uuid) === (currentUser && currentUser.id && currentUser.id.uuid);
  const sub_contracter = listingType == subListing;
  const typeOrder = {
    'business-licence': 1,
    'certificate-of-insurance': 2,
    'w9-form': 3,
  };

  const sortedDocuments = documents?.sort((a, b) => {
    return (typeOrder[a.type] || Infinity) - (typeOrder[b.type] || Infinity);
  })

  const onSubmitMessage = values => {
    const { message } = values;
    const invitedProject = currentUserListings?.[0] || null;
    const projectId = invitedProject.id.uuid || "";
    const { title, publicData } = invitedProject.attributes || {};
    onContactProfessional(listingId, message, title, projectId, publicData, title)
      .then(txId => {
        history.push(
          createResourceLocatorString(
            'OrderDetailsPage',
            routeConfiguration,
            { id: txId.uuid }
          ));
      });
  };

  const { invitations, listingId: userListingId } = profileUser && profileUser.id && profileUser.attributes.profile.publicData || {};
  const id = new UUID(userListingId)
  const handleInviteSubmit = (projectId) => {
    const profileId = isprofileUser;
    const invitedProject = currentUserListings?.find(l => l.id.uuid === projectId);
    const { title, publicData } = invitedProject.attributes || {};
    const projectTitle = invitedProject.attributes.title;
    const { existingInvites = [] } = publicData;
    onInviteProfessional({ profileId, projectId, listingId: id, projectTitle, config, publicData, title, existingInvites });
  };

  return (
    <div className={css.asideContent}>
      {isOwnListing && sub_contracter ?
        <div className={css.mobileOwnUserBox}>
          <FormattedMessage id="ProfessionalPage.ownProfile" />
          <NamedLink
            className={classNames(css.navigationLinkText)}
            name="EditListingPage"
            params={{ slug: title, id: listingId.uuid, type: "edit", tab: 'details' }}
          >
            <IconCard brand="edit" />
            {
              listingState == LISTING_STATE_DRAFT ?
                <FormattedMessage id="ProfessionalPage.completeProfile" />
                : <FormattedMessage id="ProfessionalPage.editProfile" />
            }

          </NamedLink>
        </div>
        : null}
      <div className={css.asiderInnerBox}>
        <AvatarLarge className={css.avatar} user={user} disableProfileLink />
        {sub_contracter
          ? <div>
            {!isOwnListing
              ?
              <PrimaryButton
                className={css.navigationMenuContent}
                onClick={() => {
                  if (currentUser) {
                    setState({ ...state, isInviteProfessionalModalOpen: true });
                  } else {
                    history.push(
                      createResourceLocatorString(
                        'SignupPage',
                        routeConfiguration,
                        {}
                      ))
                  }
                }}
              >
                <FormattedMessage id="ProfessionalPage.inviteButtonText" />
              </PrimaryButton>
              : null}
            <div className={css.buttonWrapper}>
              {!isOwnListing
                ?
                <PrimaryButton
                  className={css.contactButton}
                  onClick={() => {
                    if (currentUser) {
                      setState({ ...state, isEnquiryModalOpen: true });
                    } else {
                      history.push(
                        createResourceLocatorString(
                          'SignupPage',
                          routeConfiguration,
                          {}
                        ))
                    }
                  }}
                >
                  <FormattedMessage id="ProfessionalPage.contactButton" />
                </PrimaryButton>
                : null}
              <div className={css.socialIconLink}>
                <span className={css.socialButton} onClick={() => setState({ ...state, isShareModalOpen: true })}>
                  <IconCard brand="share" />
                </span>
              </div>
            </div>
            <div className={css.verificationBox}>
              <div className={css.verificationHeading}>
                <FormattedMessage id="ProfilePage.verification" />
              </div>
              <ul>
                {sortedDocuments && sortedDocuments.length
                  ? sortedDocuments.map(document => (
                    <li key={document.id}>
                      <a
                        href={document.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <IconCard brand="checked" />
                        {document.type}
                      </a>
                    </li>
                  ))
                  : null}
              </ul>

            </div>
            <div className={css.verificationBox}>
              <div className={css.verificationHeading}>
                <FormattedMessage id="ProfilePage.skillSet" />
              </div>
              <div className={css.categoryItem}>
                {professional_Skills?.map((item, index) => (
                  <li key={index} >
                    {item.label}
                  </li>
                ))}
              </div>
            </div>
          </div>
          : null}

        <ShareModal
          id="ListingPage.lShareModal"
          isOpen={state.isShareModalOpen}
          onCloseModal={() => setState({ ...state, isShareModalOpen: false })}
          onManageDisableScrolling={onManageDisableScrolling}
        />
        <Modal
          id="ListingPage.inquiry"
          contentClassName={css.inquiryModalContent}
          isOpen={state.isEnquiryModalOpen}
          onClose={() => setState({ ...state, isEnquiryModalOpen: false })}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <InquiryForm
            className={css.inquiryForm}
            submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
            listingTitle={title}
            contact={true}
            inviteInProgress={inviteProfessionalInProgress}
            inviteError={inviteProfessionalError}
            displayName={displayName}
            ownListings={currentUserListings}
            userInvitations={invitations}
            authorDisplayName={authorDisplayName}
            sendInquiryError={contactProfessionalError}
            onSubmit={onSubmitMessage}
            inProgress={contactProfessionalInProgress}
          />
        </Modal>
        <InviteProfessionalModal
          id="ProfessionalPage.inviteProfessionalModal"
          isOpen={state.isInviteProfessionalModalOpen}
          onCloseModal={() => setState({ ...state, isInviteProfessionalModalOpen: false })}
          onManageDisableScrolling={onManageDisableScrolling}
          onSubmit={handleInviteSubmit}
          inviteInProgress={inviteProfessionalInProgress}
          inviteError={inviteProfessionalError}
          displayName={displayName}
          ownListings={currentUserListings}
          userInvitations={invitations}
        />
        {/* <ProposalModal
          id="ProfessionalPage.proposalModal"
          isOpen={state.isProposalModalOpen}
          onCloseModal={() => setState({ ...state, isProposalModalOpen: false })}
          onManageDisableScrolling={onManageDisableScrolling}
          onSubmit={handleProposalSubmit}
          proposalInProgress={sendProposalInProgress}
          proposalError={sendProposalError}
          displayName={displayName}
          ownListings={currentUserListings}
        /> */}
      </div>


      <H2 as="h1" className={css.mobileHeading}>
        {displayName ? (
          <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: displayName }} />
        ) : null}
      </H2>
    </div>
  );
};

export const ReviewsErrorMaybe = props => {
  const { queryReviewsError } = props;
  return queryReviewsError ? (
    <p className={css.error}>
      <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
    </p>
  ) : null;
};

export const MobileReviews = props => {
  const { reviews, queryReviewsError } = props;
  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  return (
    <div className={css.mobileReviews}>
      <H4 as="h2" className={css.mobileReviewsTitle}>
        <FormattedMessage
          id="ProfilePage.reviewsFromMyCustomersTitle"
          values={{ count: reviewsOfProvider.length }}
        />
      </H4>
      <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
      <Reviews reviews={reviewsOfProvider} />
    </div>
  );
};

export const DesktopReviews = props => {
  const [showReviewsType, setShowReviewsType] = useState(REVIEW_TYPE_OF_PROVIDER);
  const { reviews, queryReviewsError } = props;
  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;

  const desktopReviewTabs = [];

  if (reviewsOfProvider.length > 0) {
    desktopReviewTabs.push({
      text: (
        <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsFromMyCustomersTitle"
            values={{ count: reviewsOfProvider.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeProviderSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
    });
  }

  if (reviewsOfCustomer.length > 0) {
    desktopReviewTabs.push({
      text: (
        <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsAsACustomerTitle"
            values={{ count: reviewsOfCustomer.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeCustomerSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
    });
  }


  return (
    <div className={css.desktopReviews}>
      <div className={css.desktopReviewsWrapper}>
        <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />

        {isReviewTypeProviderSelected ? (
          <Reviews reviews={reviewsOfProvider} />
        ) : (
          <Reviews reviews={reviewsOfCustomer} />
        )}
      </div>
    </div>
  );
};

export const CustomUserFields = props => {
  const { publicData, metadata, userFieldConfig } = props;

  const shouldPickUserField = fieldConfig => fieldConfig?.showConfig?.displayInProfile !== false;
  const propsForCustomFields =
    pickCustomFieldProps(publicData, metadata, userFieldConfig, 'userType', shouldPickUserField) ||
    [];

  return (
    <>
      <SectionDetailsMaybe {...props} />
      {propsForCustomFields.map(customFieldProps => {
        const { schemaType, ...fieldProps } = customFieldProps;
        return schemaType === SCHEMA_TYPE_MULTI_ENUM ? (
          <SectionMultiEnumMaybe {...fieldProps} />
        ) : schemaType === SCHEMA_TYPE_TEXT ? (
          <SectionTextMaybe {...fieldProps} />
        ) : null;
      })}
    </>
  );
};

export const MainContent = props => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(activeTab === index ? null : index);
  };

  const {
    userShowError,
    bio,
    displayName,
    publicData,
    currentUser,
    listings,
    showLinkToProfileSettingsPage,
    queryListingsError,
    reviews,
    queryReviewsError,
  } = props;
  const hasListings = listings && listings.length > 0;
  const isOwnListing =
    (listings[0] && listings[0].author && listings[0].author.id.uuid) === (currentUser && currentUser.id && currentUser.id.uuid);
  const { images, attributes, id, author } = listings && listings.length && listings[0] || {};
  const ListingPublicData = attributes && attributes.publicData || {};
  const { title, state } = attributes && attributes || {};
  const { location, firstName, lastName, website, listingType, serviceLocationAddresses } = ListingPublicData || {};
  const { companyName, userType, location: userLocation } = publicData || {};
  const prime_contracter = userType == userTypePrime;
  const sub_contracter = listingType == subListing;
  const listingId = id && id.uuid || "";
  const hasMatchMedia = typeof window !== 'undefined' && window?.matchMedia;
  const isMobileLayout = hasMatchMedia
    ? window.matchMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH}px)`)?.matches
    : true;

  const hasBio = !!bio;
  const bioWithLinks = richText(bio, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
  });

  const listingsContainerClasses = classNames(css.listingsContainer, {
    [css.withBioMissingAbove]: !hasBio,
  });

  if (userShowError || queryListingsError) {
    return (
      <p className={css.error}>
        <FormattedMessage id="ProfilePage.loadingDataFailed" />
      </p>
    );
  }
  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    // variableWidth: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
    ]
  };

  return (
    <div>
      {isOwnListing && sub_contracter ?
        <div className={css.ownUserBox}>
          <FormattedMessage id="ProfessionalPage.ownProfile" />
          <NamedLink
            className={classNames(css.navigationLinkText)}
            name="EditListingPage"
            params={{ slug: title, id: listingId, type: "edit", tab: 'details' }}
          >
            <IconCard brand="edit" />
            {
              state == LISTING_STATE_DRAFT ?
                <FormattedMessage id="ProfessionalPage.completeProfile" />
                : <FormattedMessage id="ProfessionalPage.editProfile" />
            }
          </NamedLink>
        </div>
        : null}
      <div className={css.titleBox}>
        <div className={css.titleRow}>
          <div>
            <H2 as="h1" className={css.desktopHeading}>
              <FormattedMessage id="ProfilePage.desktopHeading" values={{ name: displayName }} />
            </H2>

            {sub_contracter ? null : <div className={css.clientType}>
              {companyName ? companyName : null}
            </div>}
          </div>
          {showLinkToProfileSettingsPage && prime_contracter ? <div className={css.editProfileButton}>
            <NamedLink
              className={css.navigationLinkText}
              name="ProfileSettingsPage"
            >
              <FormattedMessage id="ProfessionalPage.editProfile" />
              <IconCard brand="rightarrow" />
            </NamedLink>
          </div> : null}

        </div>
        {
          prime_contracter ?
            <div>
              <div className={css.bioTitle}>
                <div className={css.bioTitle}>
                  <FormattedMessage id="ProfileSettingsForm.bioLabel" />
                </div>
                <div className={css.bioDetail}>
                  {bio}
                </div>
              </div>
              <div className={css.locationAddress}>
                <IconCard brand="location" />
                {userLocation && userLocation.address}
              </div>
            </div>
            : null
        }
      </div>

      {sub_contracter ? <div className={css.profileTabs}>
        <div className={css.tabButtons}>
          <button
            onClick={() => handleTabClick(0)}
            className={activeTab === 0 ? css.active : css.inActive}
          >
            <IconCard brand="profile" />
            <FormattedMessage id="SectionFooter.about" />
          </button>
        </div>
        <div className={css.tabContent}>
          {activeTab === 0 && (
            <div className={css.tabPane}>
              <div className={css.aboutTab}>
                <div className={css.subInfoHeading}><FormattedMessage id="ProfilePage.infoHeading" /></div>
                <div className={css.inforDetails}>
                  <div className={css.inforData}>
                    <span className={css.boldHeading}><FormattedMessage id="ProfilePage.fullNameHeading" /></span>
                    <span className={css.normalText}>{`${firstName} ${lastName}`}</span>

                  </div>
                  <div className={css.inforData}>
                    <span className={css.boldHeading}><FormattedMessage id="ProfilePage.companyHeading" /></span>
                    <span className={css.normalText}>{title}</span>
                  </div>
                  {serviceLocationAddresses ? <div className={css.inforData}>
                    <span className={css.boldHeading}><FormattedMessage id="ProfilePage.serviceLocationsHeading" /></span>
                    <span className={css.normalText}>
                      {/* {serviceLocationAddresses && serviceLocationAddresses.length > 0 && serviceLocationAddresses.map((e, index) => (
                        <span key={index}>{e + "  "}</span>
                        // <span key={index}>{`${e}     `}</span>
                      ))} */}
                      {serviceLocationAddresses && serviceLocationAddresses.length > 0 &&
                        serviceLocationAddresses.map((e, index) => {
                          const city = e.split("-")[0]; // Extract city name
                          return <span key={index}> {city}{index !== serviceLocationAddresses.length - 1 ? ", " : "  "}</span>; // Add space for separation
                        })
                      }
                    </span>
                  </div> : null}
                  <div className={css.inforData}>
                    <span className={css.boldHeading}><FormattedMessage id="ProfilePage.websiteHeading"
                      values={{
                        link: (
                          <a className={css.normalText} href={website}>
                            {" " + website}
                          </a>
                        )
                      }} /></span>

                  </div>
                </div>
              </div>
              <div className={css.bioData}>
                <div className={css.bioHeading}><FormattedMessage id="ProfileSettingsForm.bioLabel" /></div>
                <div className={css.bioDetail}>
                  {hasBio ? <>{bioWithLinks}</> : null}
                </div>
              </div>
              <div className={css.bioData}>

                <div className={css.bioHeading}><FormattedMessage id="ProfilePage.photos" values={{
                  count: images && images.length,
                }} />
                </div>
                <div className={css.sliderWrapper}>
                  {images?.length <= 2 ?
                    <div className={css.lessImageSlider}>
                      {images?.map(image => (
                        <div className={css.lessImage}
                          key={image.id.uuid}>
                          <img
                            src={image.attributes.variants["scaled-small"]?.url || image.attributes.variants["listing-card"]?.url}
                            alt={image.id.uuid}
                            height={image.attributes.variants["scaled-small"]?.url || image.attributes.variants["listing-card"]?.url}
                            width={image.attributes.variants["scaled-small"]?.url || image.attributes.variants["listing-card"]?.url}
                          />
                        </div>
                      ))}
                    </div> :
                    <Slider {...settings}>
                      {images?.map(image => (
                        <div className={css.sliderImages}
                          key={image.id.uuid}>
                          <img
                            src={image.attributes.variants["scaled-small"]?.url || image.attributes.variants["listing-card"]?.url}
                            alt={image.id.uuid}
                            height={image.attributes.variants["scaled-small"]?.url || image.attributes.variants["listing-card"]?.url}
                            width={image.attributes.variants["scaled-small"]?.url || image.attributes.variants["listing-card"]?.url}
                          />
                        </div>
                      ))}
                    </Slider>}
                </div>
              </div>
              {reviews && !reviews.length ? <div className={css.bioData}>
                <div className={css.bioHeading}>REVIEWS (0)</div>
                <div className={css.reviewDetails}>
                  <div className={css.reviewCard}>
                    <span>
                      <IconCard brand="star" />
                      Communication
                    </span>
                    <span>
                      <IconCard brand="star" />
                      Professionalism
                    </span>
                    <span>
                      <IconCard brand="star" />
                      Punctuality
                    </span>
                    <span>
                      <IconCard brand="star" />
                      Job Quality
                    </span>
                    <span>
                      <IconCard brand="star" />
                      Cleanliness
                    </span>
                  </div>
                  <div className={css.reviewDescription}>
                    Unfortunately this user doesn't have any reviews. But as all our professionals are vetted there is nothing stopping you from starting conversation.
                  </div>
                </div>
              </div> : null}
            </div>
          )}
        </div>
      </div> : null}
      {isMobileLayout ? (
        <MobileReviews reviews={reviews} queryReviewsError={queryReviewsError} />
      ) : (
        <DesktopReviews reviews={reviews} queryReviewsError={queryReviewsError} />
      )}
    </div>
  );
};

export const ProfilePageComponent = props => {
  const config = useConfiguration();
  const intl = useIntl();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    scrollingDisabled,
    params: pathParams,
    currentUser,
    useCurrentUser,
    isCurrentUserClient,
    isCurrentUserProfessional,
    userShowError,
    user,
    onSendProposal,
    sendProposalInProgress,
    sendProposalError,
    onShowUser,
    currentUserListings,
    onInviteProfessional,
    inviteProfessionalInProgress,
    inviteProfessionalError,
    onManageDisableScrolling,
    onContactProfessional,
    currentUserHasListings,
    contactProfessionalError,
    contactProfessionalInProgress,
    listings,
    ...rest
  } = props;

  const isVariant = pathParams.variant?.length > 0;
  const isPreview = isVariant && pathParams.variant === PROFILE_PAGE_PENDING_APPROVAL_VARIANT;


  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem('hasRefreshed');

    if (Array.isArray(listings) && listings.length === 0 && !hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload();
    }
  }, [listings]);

  // Stripe's onboarding needs a business URL for each seller, but the profile page can be
  // too empty for the provider at the time they are creating their first listing.
  // To remedy the situation, we redirect Stripe's crawler to the landing page of the marketplace.
  // TODO: When there's more content on the profile page, we should consider by-passing this redirection.
  const searchParams = rest?.location?.search;
  const isStorefront = searchParams
    ? new URLSearchParams(searchParams)?.get('mode') === 'storefront'
    : false;
  if (isStorefront) {
    return <NamedRedirect name="LandingPage" />;
  }

  const isDataLoaded = isPreview
    ? currentUser != null || userShowError != null
    : user != null || userShowError != null;
  const isCurrentUser = currentUser?.id && currentUser?.id?.uuid === pathParams.id;
  const profileUser = useCurrentUser ? currentUser : user;
  const { bio, displayName, publicData, metadata } = profileUser?.attributes?.profile || {};
  const { userFields } = config.user;
  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const isUnauthorizedUser = currentUser && !isUserAuthorized(currentUser);
  const isUnauthorizedOnPrivateMarketplace = isPrivateMarketplace && isUnauthorizedUser;
  const hasUserPendingApprovalError = isErrorUserPendingApproval(userShowError);

  const schemaTitleVars = { name: displayName, marketplaceName: config.marketplaceName };
  const schemaTitle = intl.formatMessage({ id: 'ProfilePage.schemaTitle' }, schemaTitleVars);

  if (!isDataLoaded) {
    return null;
  } else if (!isPreview && isNotFoundError(userShowError)) {
    return <NotFoundPage staticContext={props.staticContext} />;
  } else if (!isPreview && isForbiddenError(userShowError)) {
    // This can happen if private marketplace mode is active, but it's not reflected through asset yet.
    return (
      <NamedRedirect
        name="SignupPage"
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  } else if (!isPreview && (isUnauthorizedOnPrivateMarketplace || hasUserPendingApprovalError)) {
    return (
      <NamedRedirect
        name="NoAccessPage"
        params={{ missingAccessRight: NO_ACCESS_PAGE_USER_PENDING_APPROVAL }}
      />
    );
  } else if (isPreview && mounted && !isCurrentUser) {
    // Someone is manipulating the URL, redirect to current user's profile page.
    return isCurrentUser === false ? (
      <NamedRedirect name="ProfilePage" params={{ id: currentUser?.id?.uuid }} />
    ) : null;
  } else if ((isPreview || isPrivateMarketplace) && !mounted) {
    // This preview of the profile page is not rendered on server-side
    // and the first pass on client-side should render the same UI.
    return null;
  }
  // This is rendering normal profile page (not preview for pending-approval)
  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ProfilePage',
        name: schemaTitle,
      }}
    >
      <LayoutSideNavigation
        sideNavClassName={css.aside}
        mainColumnClassName={css.main}
        containerClassName={css.profileContainer}
        topbar={<TopbarContainer />}
        sideNav={
          <AsideContent
            user={profileUser}
            listings={listings}
            config={config}
            currentUser={currentUser}
            onShowUser={onShowUser}
            currentUserListings={currentUserListings}
            onInviteProfessional={onInviteProfessional}
            isCurrentUserClient={isCurrentUserClient}
            isCurrentUserProfessional={isCurrentUserProfessional}
            showLinkToProfileSettingsPage={isCurrentUser}
            displayName={displayName}
            onSendProposal={onSendProposal}
            sendProposalInProgress={sendProposalInProgress}
            sendProposalError={sendProposalError}
            inviteProfessionalInProgress={inviteProfessionalInProgress}
            inviteProfessionalError={inviteProfessionalError}
            contactProfessionalError={contactProfessionalError}
            contactProfessionalInProgress={contactProfessionalInProgress}
            onManageDisableScrolling={onManageDisableScrolling}
            onContactProfessional={onContactProfessional}
            currentUserHasListings={currentUserHasListings}
          />
        }
        footer={<FooterContainer />}
      >
        <MainContent
          bio={bio}
          displayName={displayName}
          userShowError={userShowError}
          publicData={publicData}
          currentUser={currentUser}
          showLinkToProfileSettingsPage={mounted && isCurrentUser}
          metadata={metadata}
          listings={listings}
          userFieldConfig={userFields}
          intl={intl}
          {...rest}
        />
      </LayoutSideNavigation>
    </Page>
  );
};

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
};

ProfilePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  useCurrentUser: bool.isRequired,
  user: oneOfType([propTypes.user, propTypes.currentUser]),
  userShowError: propTypes.error,
  queryListingsError: propTypes.error,
  listings: arrayOf(propTypes.listing).isRequired,
  reviews: arrayOf(propTypes.review),
  queryReviewsError: propTypes.error,
};

const mapStateToProps = state => {
  const { currentUser, currentUserHasListings, isCurrentUserClient, isCurrentUserProfessional } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews,
    queryReviewsError,
    inviteProfessionalInProgress,
    inviteProfessionalError,
    contactProfessionalError,
    sendProposalInProgress,
    sendProposalError,
    contactProfessionalInProgress,
    currentUserListingRefs,
  } = state.ProfilePage;
  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);
  const user = userMatches.length === 1 ? userMatches[0] : null;
  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };
  const currentUserListings = currentUserListingRefs?.map(l => getOwnListing(l.id));

  // Show currentUser's data if it's not approved yet
  const isCurrentUser = userId?.uuid === currentUser?.id?.uuid;
  const useCurrentUser = isCurrentUser && !isUserAuthorized(currentUser);

  return {
    scrollingDisabled: isScrollingDisabled(state),
    user,
    currentUser,
    useCurrentUser,
    isCurrentUserClient,
    isCurrentUserProfessional,
    contactProfessionalError,
    contactProfessionalInProgress,
    userShowError,
    currentUserListings,
    inviteProfessionalInProgress,
    inviteProfessionalError,
    queryListingsError,
    currentUserHasListings,
    sendProposalInProgress,
    sendProposalError,
    // listings: currentUserListings,
    listings: getMarketplaceEntities(state, userListingRefs) == [] ? currentUserListings : getMarketplaceEntities(state, userListingRefs),
    reviews,
    queryReviewsError,
  };
};
const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onInviteProfessional: params => dispatch(inviteProfessional(params)),
  onContactProfessional: (listingId, message, projectTitle, projectId, publicData, title) => dispatch(contactProfessional(listingId, message, projectTitle, projectId, publicData, title)),
  onSendProposal: params => dispatch(sendProposal(params)),
  onShowUser: (userId, config) => dispatch(showUser(userId, config)),

});

const ProfilePage = compose(connect(mapStateToProps, mapDispatchToProps))(ProfilePageComponent);

export default ProfilePage;
